import React, { memo, useState, useEffect, useRef } from 'react';
import 'swiper/css';
import { CertificateIcon } from '../../../../components/icons';
import { isMobile } from 'react-device-detect';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { changeTheme } from '../../../../Store/actions/settings.action';
import { useDispatch } from 'react-redux';
import PrimarySpecialitiesSkeleton from './PrimarySpecialitiesSkeleton';
// import { CertificateIcon } from '../../components/icons';

const PrimarySpecialities = ({
  onNextBtnClick,
  data,
  isLoading,
  selectedSpeciality,
  onSpecialitySelect
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log('key,data', data, isLoading);
  }, [data, isLoading]);
  return (
    <>
      <div className="container px-0 container-maxWidth">
        <div className="d-flex flex-column pt-3 pt-sm-4">
          <div className="px-3 px-sm-4 flex-1 d-flex flex-column">
            <div className="flex-1">
              <div className="row row-cols-2 row-cols-sm-3 ms-n3 mt-n3 me-0">
                {isLoading ? (
                  <PrimarySpecialitiesSkeleton />
                ) : (
                  data &&
                  data?.length > 0 &&
                  data.map((key) =>
                    key.master_specialities_id != '29' ? (
                      <div className="col ps-3 pt-3 pe-0" key={key.master_specialities_id}>
                        <div className="clr_v3_checkbox position-relative overflow-hidden clr_v3_checkbox__specialityCard">
                          <input
                            type="checkbox"
                            id={`checkbox_${key.master_specialities_id}`}
                            checked={selectedSpeciality == key.master_specialities_id}
                            onChange={() => {
                              dispatch(changeTheme(key.specialities_name));
                              onSpecialitySelect(key);
                            }}
                            className="clr_v3_checkbox__input position-absolute start-0 top-0 w-100 h-100 z-3 opacity-0"
                          />
                          <label
                            for={`checkbox_${key.master_specialities_id}`}
                            className="clr_v3_checkbox__label position-relative overflow-hidden rounded-3 p-3 border border-105 border-light w-100 h-100"
                          >
                            <div className="overlay z-1 bg-primary"></div>
                            <div className="clr_v3_checkbox__content d-flex flex-column justify-conntent-between">
                              <div className="d-flex align-items-center justify-content-center p-2 clr_v3_checkbox__specialityIcon mb-3">
                                {/* {<CertificateIcon />} */}
                                {key.icon && (
                                  <LazyImage
                                    className="w-auto h-auto mw-100 mh-100"
                                    src={key.icon}
                                    alt={key.specialities_name}
                                  />
                                )}
                              </div>
                              <span className="flex-1 mt-auto">{key.specialities_name}</span>
                            </div>
                            <div className="clr_v3_checkbox__icon d-flex align-items-center justify-content-center z-2 rounded-circle position-absolute start-50 top-50">
                              <i className="flaticon-check fs-30"></i>
                            </div>
                          </label>
                        </div>
                      </div>
                    ) : null
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(PrimarySpecialities);
